var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16634 18.3332C3.94533 18.3332 3.73337 18.2454 3.57709 18.0891C3.42081 17.9328 3.33301 17.7209 3.33301 17.4998V2.49984C3.33301 2.27882 3.42081 2.06686 3.57709 1.91058C3.73337 1.7543 3.94533 1.6665 4.16634 1.6665H15.833C16.054 1.6665 16.266 1.7543 16.4223 1.91058C16.5785 2.06686 16.6663 2.27882 16.6663 2.49984V4.99984H14.9997V3.33317H4.99967V16.6665H14.9997V14.9998H16.6663V17.4998C16.6663 17.7209 16.5785 17.9328 16.4223 18.0891C16.266 18.2454 16.054 18.3332 15.833 18.3332H4.16634ZM14.9997 13.3332V10.8332H9.16634V9.1665H14.9997V6.6665L19.1663 9.99984L14.9997 13.3332Z",
    fill: "#A1A6B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bf1ace2a1c411dfafc0e06b1eb56efa0.svg";
export { ForwardRef as ReactComponent };